// extracted by mini-css-extract-plugin
module.exports = {"Support":"style_Support__24Xzd","ImageContainer":"style_ImageContainer__3P7t0","Text":"style_Text__2cwgC"};